module.exports = __webpack_public_path__ + "img/line3.ba2e8782.svg";